// 系统名
export const title = 'A.I.英语听说课堂'
// 页脚公司名
export const loginFooter = '中科启云（广州）数字科技有限公司  1.0.1'
// 版本号
export const version = '3.0.0'
/* 1:西柚 */
export const belong = 1

export const masters = '_Sts100#@'

// 播放顺序
export const playOrder = {
  0: 'sequential', // 顺序
  1: 'random' // 随机
}

// 播放模式
export const playMode = {
  0: 'manual', // 手动
  1: 'auto' // 字段
}

// 年级数据map
export const gradeData = {
  0: '六年级',
  1: '七年级',
  2: '八年级',
  3: '九年级',
  4: '高一',
  5: '高二',
  6: '高三',
  7: '初中',
  8: '高中',
  9: '小学',
  100: '幼儿园',
  101: '一年级',
  102: '二年级',
  103: '三年级',
  104: '四年级',
  105: '五年级'
}

// 模块分类
export const category = {
  1: '普通模块',
  2: '模考类型模块',
  3: '听说专区',
  4: '读写专区',
  5: '热门推荐',
  6: '教辅',
  7: '内容平台素材'
}
// 模块类型
export const moduleType = {
  1: '听说读写',
  4: '单词',
  5: '音标',
  6: '课文听读',
  8: '扩展练习',
  9: '趣味配音',
  11: '我的教辅',
  12: '同步课时练',
  13: '资源中心',
  14: '假期作业',
  15: '同步诗词',
  16: '普通诗词'
}

// 首页模块背景样式类名
export const bgClassList = {
  word: 'bg-FF8436-FF9F61',
  text: 'bg-4772FF-6286FF',
  auxiliary: 'bg-0E8FA3-2ABCD2',
  special: 'bg-6C6EFF-8688FF',
  pk: 'bg-FF3767-FF6086',
  work: 'bg-0979D7-2F9CF7',
  exam: 'bg-FB4A4F-FF6B6F',
  condition: 'bg-A146FC-B265FF',
  setting: 'bg-6375AF-91A1D3',
  else: 'bg-09904B-25BF70'
}
// 作答情况类型
export const answerType = {
  1: '单词',
  2: '单项填空、多项填空、听说混选题、听说填空',
  3: '词汇运用、听说选择题',
  4: '课文听读、朗读、跟读、复述'
}
// 模式列表
export const modeList = [
  { id: 1, text: '朗读' },
  { id: 2, text: '跟读' },
  { id: 3, text: '复述' }
]

// 模块列表
export const moduleList = [
  {
    free: 1,
    gradeTypeId: 8,
    id: '111',
    src: require('@/assets/home/home_special.png'),
    name: '本地专版',
    toPublic: 1,
    type: 12,
    path: 'SpecialBookList'
  }
  // {
  //   free: 1,
  //   gradeTypeId: 8,
  //   id: '',
  //   mainPhoto: require('@/assets/home/home_pk.png'),
  //   name: '单词PK',
  //   toPublic: 1,
  //   type: 13,
  //   path: 'CreatePk',
  //   query: {
  //     origin: 'index'
  //   },
  //   classType: 'pk'
  // },
  // {
  //   free: 1,
  //   gradeTypeId: 8,
  //   id: '112',
  //   mainPhoto: require('@/assets/home/home_work.png'),
  //   name: '作业',
  //   toPublic: 1,
  //   type: 12,
  //   path: '',
  //   classType: 'work'
  // },
  // {
  //   free: 1,
  //   gradeTypeId: 8,
  //   id: '113',
  //   mainPhoto: require('@/assets/home/home_exam.png'),
  //   name: '考试',
  //   toPublic: 1,
  //   type: 12,
  //   path: 'PkContainer',
  //   classType: 'exam'
  // },
  // {
  //   free: 1,
  //   gradeTypeId: 8,
  //   id: '114',
  //   mainPhoto: require('@/assets/home/home_case.png'),
  //   name: '学情',
  //   toPublic: 1,
  //   type: 12,
  //   path: '',
  //   classType: 'condition'
  // },
  // {
  //   free: 0,
  //   gradeTypeId: 8,
  //   id: '115',
  //   mainPhoto: require('@/assets/home/home_setting.png'),
  //   name: '班级设置',
  //   toPublic: 1,
  //   type: 12,
  //   path: '',
  //   classType: 'setting'
  // },
  // {
  //   free: 0,
  //   gradeTypeId: 8,
  //   id: '116',
  //   mainPhoto: '',
  //   name: '其他',
  //   toPublic: 1,
  //   type: 12,
  //   path: '',
  //   classType: 'else'
  // }
]
// 流程类型表
export const ProcessTypeEnum = {
  1: { key: 'PLAY_QUESTION_STEM', name: '播放题干' },
  2: { key: 'PLAY_ORIGINAL_TEXT', name: '播放原文' },
  3: { key: 'WAIT_TIME', name: '等待时间' },
  4: { key: 'RECORDED_ANSWER', name: '录音作答' },
  5: { key: 'PLAY_VIDEO', name: '播放视频' },
  6: { key: 'CHOICE_QUESTIONS_AUDIO', name: '选择题音频' },
  7: { key: 'TEXT_READING_ALOUD', name: '课文朗读' },
  8: { key: 'MIXED_CHOICE_QUESTIONS_MULTI_AUDIO', name: '混合选择题多音频' },
  9: { key: 'OPTIONS_TICK', name: '选项勾选' },
  10: { key: 'PLAY_SHORT_TEXT', name: '播放短文' }
}

// 题型类型枚举
export const showTypeEnum = {
  0: '视频',
  1: '图片',
  2: '文本',
  3: '单音频选择题',
  4: '多音频选择题',
  5: '填空题'
}

// 评测类型枚举
export const oralTypeEnum = {
  0: { key: 'unknow', name: '请选择', id: 0 },
  1: { key: 'oralTypeWord', name: '单词', id: 1 },
  2: { key: 'oralTypeSentence', name: '语句', id: 2 },
  3: { key: 'oralTypeParagraph', name: '段落', id: 3 },
  4: { key: 'oralTypeChoose', name: '选择题', id: 4 },
  5: { key: 'oralTypeEssayQuestion', name: '问答题', id: 5 },
  6: { key: 'oralTypePicture', name: '看图作文', id: 6 },
  7: { key: 'oralTypeChineseWord', name: '中文单词', id: 7 },
  8: { key: 'oralTypeChineseSentence', name: '中文句子', id: 8 },
  9: { key: 'oralTypeChinesePcha', name: '中文有限分支识别评测', id: 9 },
  10: { key: 'oralTypeChinesePred', name: '中文段落', id: 10 },
  11: { key: 'oralTypeEnglishPcha', name: '英文有限分支识别评测', id: 11 },
  12: { key: 'oralTypeAlpha', name: '字母评测', id: 12 },
  13: { key: 'oralTypeRec', name: '自由识别', id: 13 },
  14: { key: 'oralTypePcha', name: '句子选读', id: 14 },
  15: { key: 'oralTypeRetell', name: '故事复述', id: 15 },
  16: { key: 'oralTypePche', name: '扩展选择', id: 16 },
  100: { key: 'oralTypeTranslateQuestion', name: '翻译', id: 100 }
}
// 音素枚举
export const PhonemeContrastEnum = {
  ih: 'ɪ',
  ax: 'ə',
  oo: 'ɒ',
  uh: 'ʊ',
  ah: 'ʌ',
  eh: 'e',
  ae: 'æ',
  iy: 'iː',
  er: 'ɜː',
  ao: 'ɔː',
  uw: 'uː',
  'y uw': 'ju:',
  aa: 'ɑː',
  ey: 'eɪ',
  ay: 'aɪ',
  oy: 'ɔɪ',
  aw: 'aʊ',
  ow: 'əʊ',
  ir: 'ɪə',
  ar: 'eə',
  ur: 'ʊə',
  p: 'p',
  b: 'b',
  t: 't',
  d: 'd',
  k: 'k',
  g: 'g',
  f: 'f',
  v: 'v',
  s: 's',
  th: 'θ',
  dh: 'ð',
  z: 'z',
  sh: 'ʃ',
  zh: 'ʒ',
  ch: 'tʃ',
  jh: 'dʒ',
  hh: 'h',
  m: 'm',
  n: 'n',
  nb: 'nb',
  ng: 'ŋ',
  l: 'l',
  r: 'r',
  y: 'j',
  w: 'w',
  dr: 'dr',
  dz: 'dz',
  tr: 'tr',
  ts: 'ts'
}

// canvas 图形集合
export const elementMapEnum = {
  LINK_AREA: {
    name: '链接区域',
    icon: '',
    type: 'LINK_AREA',
    shapeType: 'RECTANGLE'
  },
  PLAY_AUDIO: {
    name: '播放音频',
    icon: require('@/assets/picture-book/audio.png'),
    type: 'PLAY_AUDIO',
    shapeType: 'ICON'
  },
  PLAY_VIDEO: {
    name: '播放视频',
    icon: require('@/assets/picture-book/video.png'),
    type: 'PLAY_VIDEO',
    shapeType: 'ICON'
  },
  PAPER_GROUP_PRACTISE: {
    name: '试题练习',
    icon: require('@/assets/picture-book/test.png'),
    type: 'PAPER_GROUP_PRACTISE',
    shapeType: 'ICON'
  },
  REFERENCE_ANSWER: {
    name: '参考答案',
    icon: require('@/assets/picture-book/answer.png'),
    type: 'REFERENCE_ANSWER',
    shapeType: 'ICON'
  },
  ANSWER_TEXTBOX: {
    name: '文本区域',
    icon: '',
    type: 'ANSWER_TEXTBOX',
    shapeType: 'RECTANGLE'
  },
  TEXT_TRANSLATE: {
    name: '原文翻译',
    icon: require('@/assets/picture-book/translation.png'),
    type: 'TEXT_TRANSLATE',
    shapeType: 'ICON'
  },
  PRACTISE_JUMP: {
    name: '练习',
    icon: require('@/assets/picture-book/jump.png'),
    type: 'PRACTISE_JUMP',
    shapeType: 'ICON'
  },
  AUDIO: {
    name: '音频',
    icon: require('@/assets/picture-book/user_audio.png'),
    type: 'AUDIO',
    shapeType: 'ICON'
  },
  VIDEO: {
    name: '视频',
    icon: require('@/assets/picture-book/user_video.png'),
    type: 'VIDEO',
    shapeType: 'ICON'
  },
  IMAGE: {
    name: '图片',
    icon: require('@/assets/picture-book/user_photo.png'),
    type: 'IMAGE',
    shapeType: 'ICON'
  },
  TEXT: {
    name: '文本',
    icon: require('@/assets/picture-book/user_text.png'),
    type: 'TEXT',
    shapeType: 'ICON'
  },
  PRACTISE: {
    name: '练习',
    icon: require('@/assets/picture-book/user_ractice.png'),
    type: 'PRACTISE',
    shapeType: 'ICON'
  }
}

// 拖放时鼠标样式
export const cursorMapEnum = {
  upperLeft: 'nw-resize',
  upper: 'n-resize',
  upperRight: 'ne-resize',
  right: 'e-resize',
  lowRight: 'se-resize',
  lower: 's-resize',
  leftLower: 'sw-resize',
  left: 'w-resize'
}

// 控件数据模板
export const controlJsonEnum = {
  // 链接区域
  LINK_AREA: {
    type: 'LINK_AREA',
    // 控件数据
    control: {
      // 父级控件id, 若无则为null
      parentId: null,
      // 控件id,uuid,新建时随机生成
      id: '',
      // 控件类型 （参考 https://mddpg4a6gl.feishu.cn/wiki/wikcnQkWz4sT0v9zxZdVTqs4yec）
      type: 'LINK_AREA',
      // 控件区域形状, RECTANGLE-矩形
      shapeType: 'RECTANGLE',
      // 控件区域数据[width, height]
      shapeData: [],
      // 控件位置坐标，左上角 [x, y]
      position: [],
      // 控件版本
      version: process.env.VUE_APP_VERSION,
      // 关联页面id, uuid
      pageId: '',
      // 控件关联的所有页面
      pageIdList: []
    },
    // 控件内容
    content: {
      // 媒体来源 CUSTOM-自定义  PAPER_GROUP-试题素材
      mediaFromType: '',
      // 媒体url，必填
      mediaUrl: '',
      // 媒体类型 AUDIO-音频 VIDEO-视频，必填
      mediaType: '',
      // 媒体时长（秒），必填
      mediaDuration: 0,
      // 翻译，非必填
      translatedText: ''
    }
  },
  // 播放音频
  PLAY_AUDIO: {
    // 控件类型
    type: 'PLAY_AUDIO',
    // 控件数据
    control: {
      // 父级控件id, 若无则为null
      parentId: null,
      // 控件id,uuid,新建时随机生成
      id: '',
      // 控件类型
      type: 'PLAY_AUDIO',
      // 控件区域形状, ICON-图标
      shapeType: 'ICON',
      // 控件区域数据[width, height]
      shapeData: [],
      // 控件位置坐标[x, y]
      position: [],
      // 控件版本
      version: process.env.VUE_APP_VERSION,
      // 关联页面id, uuid
      pageId: '',
      // 控件关联的所有页面
      pageIdList: []
    },
    // 控件内容
    content: {
      // 媒体来源 CUSTOM-自定义  PAPER_GROUP-试题素材
      mediaFromType: '',
      // 媒体url，必填
      mediaUrl: '',
      // 媒体类型 AUDIO-音频，必填
      mediaType: '',
      // 媒体时长（秒），必填
      mediaDuration: 0,
      // 录音材料，非必填
      tapescripts: ''
    }
  },
  // 播放视频
  PLAY_VIDEO: {
    // 控件类型
    type: 'PLAY_VIDEO',
    // 控件数据
    control: {
      // 父级控件id, 若无则为null
      parentId: null,
      // 控件id,uuid,新建时随机生成
      id: '',
      // 控件类型
      type: 'PLAY_VIDEO',
      // 控件区域形状, ICON-图标
      shapeType: 'ICON',
      // 控件区域数据[width, height]
      shapeData: [],
      // 控件位置坐标[x, y]
      position: [],
      // 控件版本
      version: process.env.VUE_APP_VERSION,
      // 关联页面id, uuid
      pageId: '',
      // 控件关联的所有页面
      pageIdList: []
    },
    // 控件内容
    content: {
      // 媒体来源 CUSTOM-自定义  PAPER_GROUP-试题素材
      mediaFromType: '',
      // 媒体url，必填
      mediaUrl: '',
      // 媒体类型 VIDEO-音频，必填
      mediaType: '',
      // 媒体时长（秒），必填
      mediaDuration: 0,
      // 录音材料，非必填
      tapescripts: ''
    }
  },
  // 试题练习
  PAPER_GROUP_PRACTISE: {
    // 控件类型
    type: 'PAPER_GROUP_PRACTISE',
    // 控件数据
    control: {
      // 父级控件id, 若无则为null
      parentId: null,
      // 控件id,uuid,新建时随机生成
      id: '',
      // 控件类型
      type: 'PAPER_GROUP_PRACTISE',
      // 控件区域形状, ICON-图标
      shapeType: 'ICON',
      // 控件区域数据[width, height]
      shapeData: [],
      // 控件位置坐标[x, y]
      position: [],
      // 控件版本
      version: process.env.VUE_APP_VERSION,
      // 关联页面id, uuid
      pageId: '',
      // 控件关联的所有页面
      pageIdList: []
    },
    // 控件内容
    content: {
      // 试题题组id，必填，旧后管的题目
      groupId: '',
      // 练习题型id，必填，对应的是大题id
      questionId: ''
    }
  },
  // 参考答案
  REFERENCE_ANSWER: {
    // 控件类型
    type: 'REFERENCE_ANSWER',
    // 控件数据
    control: {
      parentId: null,
      // 控件id,uuid,新建时随机生成
      id: '',
      // 控件类型
      type: 'REFERENCE_ANSWER',
      // 控件区域形状, ICON-图标
      shapeType: 'ICON',
      // 控件区域数据[width, height]
      shapeData: [],
      // 控件位置坐标[x, y]
      position: [],
      // 控件版本
      version: process.env.VUE_APP_VERSION,
      // 关联页面id, uuid
      pageId: '',
      // 控件关联的所有页面
      pageIdList: []
    },
    // 控件内容
    content: {
      // 显示方式 UN_SHOW-不展示 POP_UP-弹出, AREA_SHOW-指定区域显示
      showMode: 'POP_UP',
      // 弹出时的内容, 必填
      text: '',
      // 指定区域内容
      areas: []
    }
  },
  // 文本区域
  ANSWER_TEXTBOX: {
    // 父级控件id
    parentId: '',
    // 区域uuid
    id: '',
    // 控件类型
    type: 'ANSWER_TEXTBOX',
    // 控件区域形状, rectangle矩形
    shapeType: 'RECTANGLE',
    // 控件区域数据[width, height]
    shapeData: [],
    // 控件位置坐标[x, y]
    position: [],
    // 关联页面id, uuid
    pageId: '',
    // 内容
    text: ''
  },
  // 原文翻译
  TEXT_TRANSLATE: {
    // 控件类型
    type: 'TEXT_TRANSLATE',
    // 控件数据
    control: {
      // 控件id,uuid,新建时随机生成
      id: '',
      // 控件类型
      type: 'TEXT_TRANSLATE',
      // 控件区域形状, ICON-图标
      shapeType: 'ICON',
      // 控件区域数据[width, height]
      shapeData: [],
      // 控件位置坐标[x, y]
      position: [],
      // 控件版本
      version: process.env.VUE_APP_VERSION,
      // 关联页面id, uuid
      pageId: '',
      // 控件关联的所有页面
      pageIdList: []
    },
    // 控件内容
    content: {
      // 原文，必填
      originalText: '',
      // 译文，必填
      translatedText: ''
    }
  }
}

// 用来标记那些字段需要必填校验
export const requiredInfoEnum = {
  LINK_AREA: ['mediaUrl', 'mediaType', 'mediaDuration'],
  PLAY_AUDIO: ['mediaUrl', 'mediaType', 'mediaDuration'],
  PLAY_VIDEO: ['mediaUrl', 'mediaType', 'mediaDuration'],
  PAPER_GROUP_PRACTISE: ['groupId', 'questionId'],
  REFERENCE_ANSWER: ['text'],
  TEXT_TRANSLATE: ['originalText', 'translatedText']
}

export const helpUrl = 'https://image.queryall.cn/public_video/aiclassrom-help.mp4'
// 客服
export const serviceTel = '400-996-0201'

// 选项下标与单词对应关系
export const optionIndexMap = {
  0: 'A',
  1: 'B',
  2: 'C',
  3: 'D'
}

// 答题器选择的答案与索引对应关系
export const optionStrMap = {
  A: 0,
  B: 1,
  C: 2,
  D: 3
}

export const pointerAnsStrMap = {
  A: { key: 'prev', name: '上一句' },
  B: { key: 'next', name: '下一个' },
  C: { key: 'start', name: '开始录音' },
  D: { key: 'random', name: '开始随机点名' },
  E: { key: 'window-max', name: '软件最大化' },
  F: { key: 'window-min', name: '软件最小化' },
  G: { key: 'stop', name: '暂停' }
}

export const wordModeTypeMap = {
  1: '单词朗读',
  2: '看词选义', // 之前叫词义检测
  4: '纸笔听写',
  6: '听词选义',
  8: '单词PK',
  9: '听音选词',
  16: '领读'
}

export const articleDialogueModeTypeMap = {
  1: '单人朗读',
  10: '角色对话',
  11: '逐句背诵',
  12: '领读'
}

export const articlePassageModeTypeMap = {
  1: '通篇朗读',
  10: '逐句跟读',
  11: '逐句背诵',
  12: '领读'
}

export const sentenceModeTypeMap = {
  1: {
    text: '朗读句子',
    routeName: 'ReadSentence'
  },
  2: {
    text: '听选句子',
    routeName: 'ChooseSentenceByHearing'
  }
}

export const loginPlatformMap = {
  middleSchool: '我是中学教师',
  gradeSchool: '我是小学教师'
}

export const homeworkStatusMap = {
  0: {
    text: '未开始',
    color: 'blue'
  },
  1: {
    text: '进行中',
    color: 'green'
  },
  2: {
    text: '已结束',
    color: 'gray'
  }
}

export const weekdayMap = {
  0: '周日',
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六'
}

// 导出任务状态
export const exportTaskStatusMap = {
  RUNNING: {
    tip: '数据准备中',
    icon: 'export-prepare'
  },
  FINISHED: {
    tip: '数据准备成功',
    icon: 'export-success'
  },
  FAILED: {
    tip: '数据准备失败',
    icon: 'export-fail'
  }
}

// 答题器类型枚举
export const classDeviceTypeMap = {
  18: {
    sampleRate: 44100,
    audioType: 'mp3'
  },
  98: {
    sampleRate: 16000,
    audioType: 'mp3'
  },
  4: {
    sampleRate: 16000,
    audioType: 'ogg'
  }
}

export const pkQuestionTypeList = [
  { id: 2, text: '看词选义' },
  { id: 3, text: '看义选词' },
  { id: 12, text: '看音选词' },
  { id: 14, text: '看义拼词' },
  { id: 15, text: '看音拼词' },
  { id: 6, text: '听词选义' },
  { id: 9, text: '听音选词' }
]

export const pkQuestionTypeMap = {
  2: {
    label: '看词选义'
  },
  3: {
    label: '看义选词'
  },
  6: {
    label: '听词选义'
  },
  9: {
    label: '听音选词'
  },
  12: {
    label: '看音选词'
  },
  14: {
    label: '看义拼词'
  },
  15: {
    label: '看音拼词'
  }
}
